module.exports = __webpack_public_path__ + "img/placeInfo_swiper.7ae629af.png";